// Zendesk renders the floating launcher and messaging window in iframes whose
// identifiers vary between widget versions and rendering states.
const ZENDESK_WIDGET_SELECTOR = [
  '#launcher',
  '#launcher-frame',
  '[id^="web-messenger"]',
  '[id*="zendesk" i]',
  '[class*="zendesk" i]',
  'iframe[title*="messaging" i]',
  'iframe[title*="launch" i]',
  'iframe[src*="zendesk.com"]',
  'iframe[src*="zdassets.com"]',
].join(', ')

const getBodyChild = (element: Element) => {
  let bodyChild = element

  while (bodyChild.parentElement && bodyChild.parentElement !== document.body) {
    bodyChild = bodyChild.parentElement
  }

  return bodyChild.parentElement === document.body ? bodyChild : null
}

export const addHiddenPrintClassToZendeskWidget = () => {
  document
    .querySelectorAll<HTMLElement>(ZENDESK_WIDGET_SELECTOR)
    .forEach(widgetElement => {
      widgetElement.classList.add('hidden-print')
      getBodyChild(widgetElement)?.classList.add('hidden-print')
    })
}
